module.exports = __webpack_public_path__ + "img/0S6A96344.569033e6.jpg";